/**
 * API文档地址
 * http://yapi.kapeixi.cn/project/809/interface/api/cat_8992
 */

import { message } from 'ant-design-vue'
import {
  category_addOrUpdate_post,
  category_delete_post,
  category_list_post
} from 'server/modules/8992'

// 新增Or更新页面或模块
export const category_addOrUpdate_post_ = async function(params) {
  const { success, data, retInfo } = await category_addOrUpdate_post(params)
  if (success) {
    message.success(retInfo)
    return Promise.resolve(data)
  } else {
    message.error(retInfo)
    return Promise.reject(data)
  }
}

// 新增Or更新页面或模块
export const category_delete_post_ = async function(params) {
  console.log(params)
  const { success, retInfo } = await category_delete_post(params)
  if (success) {
    message.success(retInfo)
  } else {
    message.error(retInfo)
  }
  // return data
}

// 页面模块列表
export const category_list_post_ = async function(params) {
  const { success, data, retInfo } = await category_list_post(params)
  if (!success) {
    message.error(retInfo)
  }
  return data
}
